
@if(user){
    <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="p-3">
        <!-- AVATAR -->
        <div class="mb-3 text-center">
            
            <img [src]=" user.avatar ? apiUrl + user.avatar : '/images/user/avatar.png'" alt="Avatar" class="rounded-circle mb-2" width="100" height="100">
    
            <!-- Bouton pour changer l’avatar -->
            <div>
                <input type="file" class="form-control d-none" #avatarInput (change)="onAvatarSelected($event)">
                <button type="button" class="btn btn-outline-primary mt-2" (click)="avatarInput.click()">
                    <i class="bi bi-image"></i> Modifier mon avatar
                </button>
            </div>
        </div>
    
        <div class="row mb-3">
            <div class="col-md-6">
                <label>Prénom</label>
                <input type="text" class="form-control" formControlName="firstName">
            </div>
            <div class="col-md-6">
                <label>Nom</label>
                <input type="text" class="form-control" formControlName="lastName">
            </div>
        </div>
    
        <div class="mb-3">
            <label>Email</label>
            <input type="email" class="form-control" formControlName="email">
        </div>
    
        <div class="mb-3">
            <label>Téléphone</label>
            <input type="text" class="form-control" formControlName="phoneNumber">
        </div>
    
        <div formGroupName="address" class="mb-3">
            <label>Adresse</label>
            <input type="text" class="form-control mb-2" formControlName="street" placeholder="Rue">
            <input type="text" class="form-control mb-2" formControlName="number" placeholder="Numéro">
            <input type="text" class="form-control mb-2" formControlName="zipCode" placeholder="Code postal">
            <input type="text" class="form-control mb-2" formControlName="city" placeholder="Ville">
            <input type="text" class="form-control" formControlName="country" placeholder="Pays">
        </div>
    
        <div class="text-end">
            <button type="button" class="btn btn-light mx-3" (click)="onCancel()">
                <i class="bi bi-x-circle"></i> annuler
            </button>
            <button type="submit" class="btn btn-primary">
                <i class="bi bi-check-circle"></i> Sauvegarder
            </button>
        </div>
    </form>
}